// extracted by mini-css-extract-plugin
module.exports = {"container":"PaymentLink_container__1hacg","footer":"PaymentLink_footer__3r_-f","footerBtn":"PaymentLink_footerBtn__3Z2ik","copyright":"PaymentLink_copyright__2Nubb"};